import * as graphql from '@treams/treams-network';

import { useWorkspace } from './useWorkspace';

export function useSupportedLanguageIDs(): { languageIDs: string[]; loading: boolean } {
	const workspace = useWorkspace();
	const { data, loading } = graphql.useSupportedLanguagesQuery({
		variables: { id: workspace.id },
		fetchPolicy: 'cache-first',
	});

	return {
		languageIDs: data?.workspace.supportedLanguageIDs ?? ['nl_NL', 'en_US'],
		loading,
	};
}
